import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/global.scss';
import 'swiper/css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './core/store';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>
);
